import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ModulesService {

  constructor(private http: HttpClient) { 
  }
  roleName : any;
  public roleInfo: any;
  modulesByRole : any;
  getModulesByRoleId(Id: string): Observable<any> {
        const httpOptions = {
          params: { 'uiRoleId': Id }
        };
        return this.http.get(environment.WebApiURL + 'api/Authentication/GetModulesByRoleId', httpOptions).pipe(map(response => {
          return response
        }));
  }

  getRoleByRoleId(RoleId: any): Observable<any> {
    return this.http.get(`${environment.WebApiURL}api/User/GetRoleByRoleId?uiRoleId=` + RoleId).pipe(map((response: any) => {
      this.roleInfo = response;
      userRoleInfo.data = response;
      return response;
    }));
  }
  
  AfterLogin(data: any): Observable<any> {
    const headers = {
      'Authorization': 'Bearer ' + data.accessToken,
      'IgnoreInterceptor': ''
    }

    return this.http.get(`${environment.WebApiURL}api/User/GetRoleByRoleId?uiRoleId=` + data.roleId, { headers }).pipe(map((response: any) => {
      return response
    }));
  }

  checkMenuAccess(data: any) {
    const headers = {
      'Authorization': 'Bearer ' + data.accessToken,
      'IgnoreInterceptor': ''
    }
    return this.http.get(`${environment.WebApiURL}api/Authentication/GetModulesByRoleId?uiRoleId=` + data.roleId, { headers }).pipe(map((response: any) => {
      return response
    }));
  }

  getCreatedByUsers(uiClientId: any,uiTeamId:any): Observable<any> {
    // uiClientId = uiClientId == null ? '' : uiClientId
    const body = {
      uiClientId: uiClientId,
      uiTeamId: uiTeamId 
    };

    return this.http.post(`${environment.WebApiURL}api/User/GetUserByClientId`, body).pipe(map((response: any) => {
      return response.data
    }));
  }

  getCreatedByTeams(uiClientId: any): Observable<any> {
    uiClientId = uiClientId == null ? '' : uiClientId
    return this.http.post(`${environment.WebApiURL}api/Team/GetTeamByClientId`, uiClientId).pipe(map((response: any) => {
      return response.data
    }));
  }

}



export const userRoleInfo: any = {
  data: ''
};
